import React, { Component } from 'react';
import NavBar from '../IndexNavBar/index';
import DirectPay from '../Payment/DirectPay';

class Purchase extends Component {

    render() {
        return (
            <>
                <NavBar />
                <div className="parallax-curso-completo heigthfull">
                    <div className="container">
                        <DirectPay />
                    </div>
                </div>
            </>
        );
    }
}

export default Purchase;